module.exports = __webpack_public_path__ + "../resources/img/ic_re_tv_default.1e60c1da.svg";